export const iconFontAwesomeTextformattingSuperscript = (
	<i className="fa-solid fa-superscript"></i>
);
